export const ENTRY_ROUTE_NAME_FOR_STAFF = 'dashboard'
export const ENTRY_ROUTE_NAME_FOR_OWNERS = 'objects-realty'
export const ENTRY_ROUTE_NAME_FOR_REDIRECT = 'admin-panel-entry-route'
export const LOGOUT_ROUTE_NAME = 'logout'
export const LOGIN_ROUTE_NAME = 'login'
export const OWNER_REGISTRATION_ROUTE_NAME = 'registration'
export const NETWORK_ISSUE_ROUTE_NAME = 'network-issue'
export const MAIN_SITE_GENERAL_PAGE_ROUTE_NAME = 'https://newmoscowhouse.ru/'
